<template lang="pug">
  .list-driver-delivery
    b-spinner.d-flex.justify-content-center(
      v-if="loadDriverRoutes"
      style="width: 5rem;position: absolute;top: 45%;left: 47.5%;height: 5rem;"
    )

    //- Date range filter
    .date-range-filter(v-if="!loadDriverRoutes")
      .date-range-filter__field
        label.date-range-filter__label Desde
        b-form-input.date-range-filter__input(
          type="date"
          v-model="localFrom"
          @change="onDateChange"
        )
      .date-range-filter__field
        label.date-range-filter__label Hasta
        b-form-input.date-range-filter__input(
          type="date"
          v-model="localTo"
          @change="onDateChange"
        )

    //- Selection mode toolbar
    .selection-toolbar(v-if="!loadDriverRoutes && canSelectDeliveries")
      .selection-toolbar__left
        b-button.selection-toolbar__toggle(
          size="sm"
          :variant="selectionMode ? 'dark' : 'outline-dark'"
          @click="toggleSelectionMode"
        )
          .material-icons {{ selectionMode ? 'close' : 'checklist' }}
          span {{ selectionMode ? 'Cancelar' : 'Seleccionar envíos' }}
      .selection-toolbar__right(v-if="selectionMode")
        b-button.selection-toolbar__select-all(
          size="sm"
          variant="secondary"
          @click="toggleSelectAll"
        ) {{ allSelected ? 'Deseleccionar todo' : 'Seleccionar todo' }}

    draggable(v-model="deliveryList" handle=".delivery-card-drag-icon" @end="updateOrder" :disabled="selectionMode")
      delivery-card.mb-3(
        v-if="!loadDriverRoutes"
        v-for="(delivery, index) in deliveryList"
        :storeName="delivery.store ? delivery.store.name : 'No encontrado'"
        :address="delivery.address.street"
        :commune="delivery.address.commune"
        :customerName="delivery.customerName"
        :deliveryId="delivery.id"
        :notGeocodeFound="delivery.notFound ? delivery.notFound : false"
        :draggable="draggable && !selectionMode"
        :order="delivery.order"
        :key="delivery.id"
        :lat="delivery.address.latCoordinate"
        :lng="delivery.address.longCoordinate"
        :selectable="selectionMode && canSelectDeliveries"
        :selected="selectedIds.includes(delivery.id)"
        @toggleSelect="onToggleSelect"
        @changeDriver="$emit('changeDriver', [delivery])"
        @done="$emit('editFinalRoute')"
      )

    //- Infinite scroll sentinel
    .scroll-sentinel(ref="scrollSentinel")
    .loading-more(v-if="loadingMore")
      b-spinner(small)
      span.ml-2 Cargando más envíos...

    //- Floating action bar when items are selected
    transition(v-if="canSelectDeliveries" name="slide-up")
      .selection-action-bar(v-if="selectionMode && selectedIds.length > 0")
        .selection-action-bar__info
          span.selection-action-bar__count {{ selectedIds.length }}
          span &nbsp;seleccionado{{ selectedIds.length !== 1 ? 's' : '' }}
        .selection-action-bar__actions
          b-button(
            @click="emitAction('changeDriver')"
            size="sm"
            style="display: flex; align-items: center; gap: 4px"
          )
            .material-icons sync_alt
            span Cambiar conductor

    // b-button.create-delivery-btn(:to="{ name: 'CreateDriverDelivery' }")
       .material-icons add
    // b-button.optimize-delivery-btn
      | Optimizar Rutas
</template>

<script>
import DeliveryCard from './DeliveryCard'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    deliveries: {
      type: Array,
      default: () => []
    },
    draggable: {
      type: Boolean,
      default: false
    },
    showCreateButton: {
      type: Boolean,
      default: true
    },
    canSelectDeliveries: {
      type: Boolean,
      default: false
    },
    dateFrom: {
      type: String,
      default: ''
    },
    dateTo: {
      type: String,
      default: ''
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DeliveryCard,
    draggable
  },
  data() {
    return {
      deliveryList: [],
      selectionMode: false,
      selectedIds: [],
      localFrom: this.dateFrom,
      localTo: this.dateTo
    }
  },
  methods: {
    ...mapActions(['updateDriverDeliveryOrder']),
    updateOrder() {
      const data = this.deliveryList.reduce((acum, delivery, index) => acum.concat({
        id: delivery.id,
        order: index
      }), [])
      this.updateDriverDeliveryOrder({ driverId: this.user.id, data })
    },
    setupScrollObserver() {
      if (this._scrollObserver) this._scrollObserver.disconnect()
      this._scrollObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && this.hasMore && !this.loadingMore) {
          this.$emit('loadMore')
        }
      }, { rootMargin: '200px' })
      if (this.$refs.scrollSentinel) {
        this._scrollObserver.observe(this.$refs.scrollSentinel)
      }
    },
    checkSentinelVisibility() {
      if (!this.$refs.scrollSentinel || !this.hasMore || this.loadingMore) return
      const rect = this.$refs.scrollSentinel.getBoundingClientRect()
      const inView = rect.top <= (window.innerHeight + 200)
      if (inView) {
        this.$emit('loadMore')
      }
    },
    toggleSelectionMode() {
      this.selectionMode = !this.selectionMode
      if (!this.selectionMode) {
        this.selectedIds = []
        this.$emit('selectionChange', [])
      }
    },
    onToggleSelect(deliveryId) {
      const idx = this.selectedIds.indexOf(deliveryId)
      if (idx === -1) {
        this.selectedIds.push(deliveryId)
      } else {
        this.selectedIds.splice(idx, 1)
      }
      this.$emit('selectionChange', this.selectedDeliveries)
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedIds = []
      } else {
        this.selectedIds = this.deliveryList.map(d => d.id)
      }
      this.$emit('selectionChange', this.selectedDeliveries)
    },
    emitAction(actionName) {
      this.$emit('selectionAction', {
        action: actionName,
        deliveries: this.selectedDeliveries
      })
    },
    onDateChange() {
      this.$emit('dateRangeChange', { from: this.localFrom, to: this.localTo })
    }
  },
  watch: {
    deliveries() {
      this.deliveryList = this.deliveries
      // Clear selections that no longer exist in the new list
      const currentIds = this.deliveries.map(d => d.id)
      this.selectedIds = this.selectedIds.filter(id => currentIds.includes(id))
      // After new data loads, check if sentinel is already visible
      this.$nextTick(() => this.checkSentinelVisibility())
    },
    hasMore(newVal) {
      if (newVal) {
        // Reconnect observer to force a fresh intersection check
        this.$nextTick(() => {
          this.setupScrollObserver()
          this.checkSentinelVisibility()
        })
      }
    },
    dateFrom(val) {
      this.localFrom = val
    },
    dateTo(val) {
      this.localTo = val
    }
  },
  computed: {
    ...mapGetters(['user', 'loadDriverRoutes']),
    selectedDeliveries() {
      return this.deliveryList.filter(d => this.selectedIds.includes(d.id))
    },
    allSelected() {
      return this.deliveryList.length > 0 && this.selectedIds.length === this.deliveryList.length
    }
  },
  mounted() {
    this.$nextTick(() => this.setupScrollObserver())
  },
  beforeDestroy() {
    if (this._scrollObserver) this._scrollObserver.disconnect()
  }
}
</script>

<style lang="scss" scoped>
.list-driver-delivery {
  .date-range-filter {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    padding: 0 4px;

    &__field {
      flex: 1;
    }

    &__label {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: #666;
      margin-bottom: 4px;
    }

    &__input {
      font-size: 13px;
      padding: 4px 8px;
      height: 34px;
    }
  }

  .scroll-sentinel {
    height: 1px;
    width: 100%;
  }

  .loading-more {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    color: #888;
    font-size: 13px;
  }

  .selection-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 4px;

    &__toggle {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;

      .material-icons {
        font-size: 18px;
      }
    }

    &__select-all {
      font-size: 13px;
    }
  }

  .selection-action-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #666666;
    color: white;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1050;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.25);

    &__info {
      font-size: 14px;
      font-weight: 500;
    }

    &__count {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #3DF9DE;
      color: #1a1a2e;
      font-weight: 700;
      border-radius: 50%;
      width: 26px;
      height: 26px;
      font-size: 13px;
      margin-right: 4px;
    }

    &__actions {
      display: flex;
      gap: 8px;
    }

    &__btn {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      padding: 4px 10px;
      border-radius: 20px;

      .material-icons {
        font-size: 16px;
      }
    }
  }

  .create-delivery-btn {
    display: flex;
    align-content: center;
    padding: 0;
    border-radius: 50%;
    height: 60px;
    width: 60px;
    position: fixed;
    bottom: 80px;
    right: 30px;

    .material-icons {
      font-size: 50px;
      margin: auto;
    }
  }

  .optimize-delivery-btn {
    display: flex;
    align-content: center;
    padding: 0;
    height: 55px;
    width: 65px;
    position: fixed;
    bottom: 160px;
    right: 30px;
    font-size: 12px;
  }
}

// Slide-up transition for action bar
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
